module.exports = __webpack_public_path__ + "static/board-09-0aba400316aa6563a884db971c9cee7e.jpg";